import React from 'react';
import { Modal, Button } from 'react-materialize';
// eslint-disable-next-line
import M from 'materialize-css';
import 'materialize-css/dist/css/materialize.min.css';
import './style.css';


const Question = React.forwardRef(function Question(props, ref) {

  const handleNo = () => {
    props.onNo();
  }

  const handleYes = () => {
    props.onYes();
  }

  const trigger = <Button 
    style={{
      display: "flex",
      width: "210px",
      backgroundColor: "#BD207B",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "20px",
      }}
    className={props.classeBotaoPadrao}>{props.iconeBotaoPadrao} &nbsp; {props.textoBotaoPadrao}</Button>;
  return (
    <Modal
      actions={[
        <>
          <Button className={props.classeBotaoSim} onClick={handleYes} color="primary">
            {props.tituloBotaoSim}
          </Button> &nbsp;&nbsp;&nbsp;
          <Button className={props.classeBotaoNao} onClick={handleNo} color="primary">
            {props.tituloBotaoNao}
          </Button>
        </>
      ]}
      bottomSheet={false}
      fixedFooter={false}
      header={props.titulo}
      options={{
        dismissible: true,
        endingTop: '10%',
        inDuration: 250,
        onCloseEnd: null,
        onCloseStart: null,
        onOpenEnd: null,
        onOpenStart: null,
        opacity: 0.5,
        outDuration: 250,
        preventScrolling: true,
        startingTop: '4%'
      }}
      trigger={trigger}
    >
      <p>
      {props.message}
      </p>
    </Modal>)

});

export default Question;
